import { onError } from "@apollo/client/link/error";
import { ENTITY_NOT_FOUND_ERROR, INTERNAL_SERVER_ERROR } from "../../error";

export const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  if (graphQLErrors?.some((err) => err?.extensions?.code == ENTITY_NOT_FOUND_ERROR)) {
    window.location.href = "/error/404";
  }

  if (graphQLErrors?.some((err) => err?.extensions?.code == INTERNAL_SERVER_ERROR)) {
    window.location.replace(`/error/500`);
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }

  if (response && Object.prototype.hasOwnProperty.call(response, "errors")) {
    response!.errors = undefined;
  }
});
